import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import PageCaterers from './pages/PageCaterers';
import PageParents from './pages/PageParents';
import PageSchools from './pages/PageSchools';
import PageDirections from './pages/PageDirections';
import PagePlatform from './pages/PagePlatform';
import PageEcoPulse from './pages/PageEcoPulse';
import PageEcoLoop from './pages/PageEcoLoop';
import Home from './pages/Home';
import HomeEN from './pages/HomeEN';
import PageCaterersEN from './pages/PageCaterersEN';
import PageParentsEN from './pages/PageParentsEN';
import PageSchoolsEN from './pages/PageSchoolsEN';
import PageDirectionsEN from './pages/PageDirectionsEN';
import PagePlatformEN from './pages/PagePlatformEN';
import PageEcoPulseEN from './pages/PageEcoPulseEN';
import PageEcoLoopEN from './pages/PageEcoLoopEN';
import PageCSS from './pages/PageCSS';
import PageCSSEN from './pages/PageCSSEN';
import PageCoParentalite from './pages/PageCoParentalite';
import PageCoParentingEN from './pages/PageCoParentingEN';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* French */}
          <Route path="/" element={<Landing />} />
          <Route path="/caterers" element={<PageCaterers />} />
          <Route path="/parents" element={<PageParents />} />
          <Route path="/schools" element={<PageSchools />} />
          <Route path="/directions" element={<PageDirections />} />
          <Route path="/platform" element={<PagePlatform />} />
          <Route path="/ecopulse" element={<PageEcoPulse />} />
          <Route path="/ecoloop" element={<PageEcoLoop />} />
          <Route path="/css" element={<PageCSS />} />
          <Route path="/coparentalite" element={<PageCoParentalite />} />
          
          {/* Redirect old routes */}
          <Route path="/fonctionnalites-communes" element={<Navigate to="/ecopulse" replace />} />
          
          {/* English */}
          <Route path="/en" element={<HomeEN />} />
          <Route path="/en/caterers" element={<PageCaterersEN />} />
          <Route path="/en/parents" element={<PageParentsEN />} />
          <Route path="/en/schools" element={<PageSchoolsEN />} />
          <Route path="/en/directions" element={<PageDirectionsEN />} />
          <Route path="/en/platform" element={<PagePlatformEN />} />
          <Route path="/en/ecopulse" element={<PageEcoPulseEN />} />
          <Route path="/en/ecoloop" element={<PageEcoLoopEN />} />
          <Route path="/en/css" element={<PageCSSEN />} />
          <Route path="/en/coparenting" element={<PageCoParentingEN />} />
          
          {/* Redirect old EN route */}
          <Route path="/en/common-features" element={<Navigate to="/en/ecopulse" replace />} />
          
          {/* Old single-page version */}
          <Route path="/old-home" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;